
import { createApp } from 'vue';
import Loading from './loading'
// 注册一个全局自定义指令 `v-loading`
const loadingDirective = {};
loadingDirective.install = (app, options) => {
  app.directive('gxxt-loading', {
    mounted: function (el, binding, vnode) {
      const backgroundExr = el.getAttribute('loading-background');
      const customClassExr = el.getAttribute('custom-class');
      const loadingTextExr = el.getAttribute('loading-text');
      const vm = vnode.context;
      const maskWrapper = document.createElement('div')
      const mask = createApp({
        ...Loading,
        data: () => {
          return {
            customClass: vm && vm[customClassExr] || customClassExr,
            background: vm && vm[backgroundExr] || backgroundExr,
            fullscreen: !!binding.modifiers.fullscreen,
            loadingText: vm && vm[loadingTextExr] || loadingTextExr,
            visible: false,
          }
        }
      })
      el.instance = mask.mount(maskWrapper)
      el.maskWrapper = maskWrapper
      el.maskStyle = {}
      binding.value && toggleLoading(el, binding)
    },
    beforeUpdate: function (el, binding) {
      if (binding.oldValue !== binding.value) {
        toggleLoading(el, binding);
      }
    },
    unmounted: function (el, binding) {
      if (el.domInserted) {
        el.maskWrapper &&
          el.maskWrapper.parentNode &&
          el.maskWrapper.parentNode.removeChild(el.maskWrapper);
        toggleLoading(el, { value: false, modifiers: binding.modifiers });
      }
      // el.instance && el.instance.destroy();
    }
  })

  const toggleLoading = function (el, binding) {
    if (binding.value) {
      if (binding.modifiers.fullscreen) {
        insertDom(document.body, el, binding)
      } else {
        insertDom(el, el, binding)
      }
    } else {
      el.instance.visible = false;
    }
  }

  const insertDom = function (parent, el, binding) {
    parent.appendChild(el.maskWrapper)
    el.domInserted = true
    el.instance.visible = true
  }
}
export default loadingDirective